import PropTypes from 'prop-types';
import AddNodeButton from './AddNodeButton';

function NodeSpacer(props) {
  const { keyPath, canAdd = false } = props;

  return (
    <div className="icp-workflow-node-spacer">
      {canAdd ? <AddNodeButton keyPath={keyPath} /> : null}
    </div>
  );
}

NodeSpacer.propTypes = {
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  canAdd: PropTypes.bool,
};

export default NodeSpacer;
